import request from "../utils/request"
// 学校商品详情
function inquireCampusDetails(val) {
    const res = request({
        method: 'POST',
        url: "admin/school/details",
        data: val
    })
    return res
}


export {
    inquireCampusDetails
}